export const en = {
  landingPageForCompanies: {
    book_a_demo: 'Book a demo',
    company_logos_desc: 'Trusted by teams at',

    hero: {
      headline_main: 'Employee volunteering',
      headline_em: 'that just works',
      sub: "Purposely handles nonprofit matching, event logistics, and impact reporting — so your impact scales from one office to hundreds",
      cta_primary: 'See it in action →',
    },

    howItWorks: {
      eyebrow: 'How it works',
      heading_main: 'Other platforms list events',
      heading_em: 'Ours runs them',
      tagline: "Legacy tools hand you a directory. Purposely's AI handles match, ops & impact end-to-end.",
      step1: {
        title: 'Brief Purposely',
        body: 'Tell Purposely your group size, location, and the impact you care about. One minute and you\'re good to go.',
      },
      step2: {
        title: 'Get Matched',
        body: 'Our matching engine finds the right nonprofit, books the event, and creates the event page.',
      },
      step3: {
        title: 'Just Show Up',
        body: 'Your team just shows up, no admin work. Purposely tracks hours and surfaces the stories worth sharing.',
      },
      verdict: 'Skip the spreadsheets. Stop chasing sign-ups. Let your team actually show up.',
      verdictSub: 'The first volunteering platform built around an autonomous AI ops layer.',
      stats: {
        countries: { n: '25+', label: 'countries' },
        nonprofits: { n: '10,000+', label: 'nonprofits' },
        setup: { n: '2 min', label: 'to set up' },
      },
    },

    features: {
      eyebrow: 'Platform features',
      heading_main: 'An AI ops layer for',
      heading_em: 'every part of your program',
      nudges: {
        tag: 'Agentic Nudges',
        heading_main: 'An assistant that',
        heading_em: 'follows up for you',
        body: "Purposely learns each employee's rhythm and sends perfectly-timed, personalized prompts on Slack or Teams, so no shift goes unfilled and no teammate gets pestered.",
        bullets: [
          'Slack, Teams & Calendar integrations',
          'Proactive awareness date reminders',
          'Nothing falls through the cracks',
        ],
        link: 'See integrations →',
      },
      impact: {
        tag: 'Impact Reporting',
        heading_main: 'Reports that',
        heading_em: 'write themselves',
        body: 'We roll up hours, participants, geographies, and more, in seconds.',
        bullets: [
          'Track by team, location, or cause',
          'Export-ready for internal or public use',
          'Metrics built for CSR, ESG & exec reporting',
        ],
        link: 'View reporting dashboard →',
      },
      nonprofits: {
        tag: 'Intelligent Matching',
        heading_main: 'Matched nonprofits,',
        heading_em: 'big and small',
        body: "Our matching scores every nonprofit in our network against your team's interests, location, and cause priorities. We surface partners you'd never find on a directory.",
        bullets: [
          'Large national & local grassroots orgs',
          'Filtered by cause, location & event type',
          "Matched to your team's interests",
        ],
        link: 'Explore our network →',
      },
      shifts: {
        tag: 'Smart Event Management',
        heading_main: 'Smart shifts with',
        heading_em: 'zero friction',
        body: 'The system optimizes shift fill rates in real time, promoting waitlisted employees, rebalancing under-filled slots, and notifying your team the second a spot opens. No manual follow-up.',
        bullets: [
          'Multiple shift windows per event',
          'Automatic waitlist notifications',
          'Real-time availability for employees',
        ],
        link: 'See how shifts work →',
      },
    },

    testimonials: {
      heading: "Hear from the teams we've helped",
      sub: "Real stories from employees who've experienced the impact firsthand.",
    },

    stats: {
      eyebrow: 'Why it matters',
      heading: 'What our customers experience',
      item1: { n: '87%', description: 'Employees feel more connected after volunteering' },
      item2: { n: '2x', description: 'Teams that volunteer are more likely to stay' },
      item3: { n: '94%', description: 'Say Purposely helps build stronger team culture' },
    },

    cta: {
      heading_main: 'Put your volunteer program',
      heading_em: 'on autopilot',
      sub: 'Join companies building cultures their employees are proud of, and running their programs in a fraction of the time.',
      button: 'Book a demo →',
    },
  },
}
